import axios, { AxiosRequestConfig } from 'axios';
import Cookies from 'universal-cookie';

import { COOKIE_NAME_AUTH, COOKIE_RESTAURANT_ID } from '../constants/AppConstants';
import { CHANGE_PASSWORD } from '../constants/UriConstants';

const cookies = new Cookies();

const baseURL =
  typeof process.env.REACT_APP_BASE_URL === 'string'
    ? process.env.REACT_APP_BASE_URL.replace(/\/+$/, '')
    : process.env.REACT_APP_BASE_URL;

const apiClient = axios.create({
  baseURL,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
});

let requestInterceptorId: number | null = null;
let responseInterceptorId: number | null = null;

export const setupApiClientInterceptors = (removeToken: Function, showErrorModal: Function) => {
  if (requestInterceptorId !== null) {
    apiClient.interceptors.request.eject(requestInterceptorId);
  }
  if (responseInterceptorId !== null) {
    apiClient.interceptors.response.eject(responseInterceptorId);
  }

  requestInterceptorId = apiClient.interceptors.request.use((config: AxiosRequestConfig) => {
    const _config = { ...config };
    _config.headers.Authorization = cookies.get(COOKIE_NAME_AUTH);

    if (!_config?.headers?.restaurantID) {
      _config.headers.restaurantID = cookies.get(COOKIE_RESTAURANT_ID);
    }
    return _config;
  });

  responseInterceptorId = apiClient.interceptors.response.use(
    (next) => Promise.resolve(next),
    (error) => {
      if (error?.response?.status === 401 && !error.response.config.url.includes(CHANGE_PASSWORD)) {
        removeToken();
      } else if (error.response) {
        throw error;
      } else if (error.request) {
        showErrorModal('Network issues. Please try again later.');
        throw error;
      }
    }
  );
};

/** @deprecated Use setupApiClientInterceptors inside useEffect instead. */
export const interceptor = setupApiClientInterceptors;

export default apiClient;
